
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoshirdiinnovacarrental() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Innova Car Rental Services',
        heading: 'S9 Travels: Pune to Shirdi Innova Car Rental Services',
        headingDescription: 'S9 Travels offers premium Innova car rental services for travelers going from Pune to Shirdi. Whether you are visiting the sacred Shirdi Sai Baba Temple, going on a pilgrimage, or enjoying a family trip, our fleet of well-maintained Innovas ensures a comfortable and safe journey. The distance between Pune and Shirdi is approximately 185 km, and the journey takes around 4 to 4.5 hours by road. With S9 Travels, you can enjoy a stress-free and luxurious ride to one of Maharashtra’s most revered spiritual destinations.',

        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Shirdi Sai Baba Temple",
      "description": "The Shirdi Sai Baba Temple is the main attraction in the town and one of the most visited pilgrimage sites in India. Devotees come here to pay respects to Sai Baba, seek blessings, and experience the spiritual aura of this sacred place. The temple complex includes the Samadhi Mandir, Dwarkamai, Chavadi, and Sai Baba’s private quarters."
    },
    {
      "title": "Dwarkamai Masjid",
      "description": "Dwarkamai Masjid is a significant place for Sai Baba devotees. It is here that Sai Baba spent a considerable portion of his life and performed many miracles. The mosque is a peaceful spot where you can see a sacred flame, which has been burning continuously for over a century."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi is another important location in Shirdi, where Sai Baba used to rest alternately every night. It is now a shrine and offers a peaceful atmosphere for prayer and reflection. The building holds immense historical and spiritual significance."
    },
    {
      "title": "Sai Teerth Spiritual Theme Park",
      "description": "Sai Teerth Spiritual Theme Park is a unique attraction dedicated to Sai Baba, offering an immersive experience with themed displays of Sai Baba's life and teachings. The park includes an art gallery, interactive exhibits, and a grand statue of Sai Baba, making it a great place for families and children."
    },
    {
      "title": "Shani Shingnapur",
      "description": "Located about 72 km from Shirdi, Shani Shingnapur is famous for its Shani (Saturn) temple, where the idol of Lord Shani is believed to be self-manifested. The village is unique because no one has ever locked their houses here, as the locals believe that Lord Shani protects them from all harm."
    },
    {
      "title": "Baba’s Samadhi Mandir",
      "description": "The Samadhi Mandir is the most sacred place in Shirdi, where the mortal remains of Sai Baba were laid to rest. Devotees visit the Samadhi Mandir to offer prayers, light incense sticks, and seek blessings. The temple is known for its serene and divine atmosphere."
    },
    {
      "title": "Lendi Baug",
      "description": "Lendi Baug is a beautiful garden located close to Sai Baba’s Samadhi Mandir. It holds spiritual significance because Sai Baba would often spend time in this peaceful garden, where a famous neem tree still stands. The garden is an ideal place for quiet reflection and nature walks."
    },
    {
      "title": "Khandoba Temple",
      "description": "Khandoba Temple, located in Shirdi, is a historic temple dedicated to Lord Khandoba. It is believed that Sai Baba visited this temple before he arrived in Shirdi. The temple holds immense cultural and religious importance for the locals."
    },
    {
      "title": "Shri Saibaba Sansthan Trust Museum",
      "description": "The Shri Saibaba Sansthan Trust Museum is a museum that showcases the personal belongings of Sai Baba, along with other artifacts related to his life. It offers insights into the history of Sai Baba’s teachings and his legacy."
    },
    {
      "title": "Dixit Wada Museum",
      "description": "Dixit Wada Museum is another must-visit attraction for those interested in the history of Shirdi and Sai Baba. The museum houses a collection of old photographs, manuscripts, and various items related to Sai Baba's life, offering a glimpse into the past."
    }
],

"services": [
    {
      "name": "Pune to Shirdi Innova Cab Service",
      "description": "Planning a visit to the Shirdi Temple from Pune? Book an Innova cab for a comfortable and reliable journey. Whether it's a one-way trip or a round trip, our Innova cabs offer the perfect combination of luxury and convenience, making your trip to Shirdi comfortable and hassle-free."
    },
    {
      "name": "Pune to Shirdi Innova Taxi Booking",
      "description": "Easily book an Innova taxi from Pune to Shirdi for your temple visit. Our booking process is quick and simple, ensuring you have a safe and smooth ride. Enjoy the spacious interior and comfort of our Innova taxis during your journey."
    },
    {
      "name": "Book Innova for Pune to Shirdi",
      "description": "Whether you're traveling solo, with family, or in a group, an Innova is the best choice for your journey from Pune to Shirdi. With its spacious seating, ample luggage space, and smooth ride, an Innova taxi is the ideal option for your Shirdi trip."
    },
    {
      "name": "Pune to Shirdi Innova One-Way",
      "description": "Book an Innova cab for a one-way trip from Pune to Shirdi. With professional drivers and a well-maintained vehicle, you can enjoy a direct and comfortable ride to Shirdi, making your visit to the temple peaceful and stress-free."
    },
    {
      "name": "Pune to Shirdi Innova Round Trip",
      "description": "For those looking to travel to and from Shirdi on the same day, book a round-trip Innova cab from Pune. Whether it's a pilgrimage or a relaxing trip, our round-trip service ensures that your journey is smooth and hassle-free."
    },
    {
      "name": "Pune to Shirdi Innova Car Rental Service",
      "description": "Looking for a rental car for your trip to Shirdi? Book an Innova on rent and enjoy a comfortable ride to the Shirdi temple. We offer flexible rental services, including one-way and round-trip options, to ensure you have the perfect vehicle for your journey."
    },
    {
      "name": "Innova Cabs for Shirdi Temple from Pune",
      "description": "Our Innova cabs are the ideal mode of transport for your visit to the Shirdi Temple. With ample space for families or groups, comfortable seating, and air-conditioning, your ride to Shirdi will be relaxing and enjoyable."
    },
    {
      "name": "Affordable Shirdi Innova Cab",
      "description": "If you’re looking for an affordable yet comfortable taxi service from Pune to Shirdi, our Innova cabs are the perfect choice. We offer competitive pricing without compromising on quality, making your journey to Shirdi both cost-effective and comfortable."
    },
    {
      "name": "Private Innova Taxi for Shirdi Temple",
      "description": "For a more personalized experience, book a private Innova taxi for your trip to the Shirdi Temple. You can customize your itinerary, ensuring that your trip is flexible and suited to your needs."
    },
    {
      "name": "Shirdi Temple Innova Tour",
      "description": "Make your visit to Shirdi more memorable with our Innova tour service. Enjoy the convenience of a private cab while visiting the temple, along with any other nearby attractions that you may wish to explore."
    },
    {
      "name": "Shirdi Innova Taxi Fare",
      "description": "Our Shirdi Innova taxi fare is affordable, and you get the best value for the comfort and convenience provided. Book a cab today and enjoy transparent pricing with no hidden charges."
    },
    {
      "name": "Luxury Innova for Shirdi from Pune",
      "description": "For a more luxurious experience, book a luxury Innova for your trip to Shirdi. Our premium service includes high-end features for a comfortable and stylish journey, perfect for those looking for a more lavish travel experience."
    },
    {
      "name": "Shirdi Temple Visit with Innova",
      "description": "Make your visit to the Shirdi Temple more pleasant with a comfortable Innova cab. Relax and enjoy the scenic journey, knowing you are in safe hands with our experienced drivers."
    },
    {
      "name": "Group Travel for Shirdi Temple",
      "description": "Traveling in a group to Shirdi? Our Innova cabs are the ideal choice for group travel. With seating for up to 7 passengers, you can travel together in comfort, ensuring a memorable pilgrimage experience for everyone."
    },
    {
      "name": "Book Shirdi Trip in Innova",
      "description": "Booking an Innova cab for your Shirdi trip is easy. Whether you’re visiting for a religious journey or a peaceful getaway, our Innova taxis offer a smooth and enjoyable ride. Book your Innova today for an unforgettable Shirdi experience."
    }
  ],

"tableData": [
  ["Pune to Shirdi Innova Cab", "Pune to Shirdi Innova Taxi Booking"],
  ["Book Innova for Pune to Shirdi", "Pune to Shirdi Innova One-Way"],
  ["Pune to Shirdi Innova Round Trip", "Pune to Shirdi Innova Car Rental Service"],
  ["Innova Cabs for Shirdi Temple from Pune", "Affordable Shirdi Innova Cab"],
  ["Private Innova Taxi for Shirdi Temple", "Shirdi Temple Innova Tour"],
  ["Shirdi Innova Taxi Fare", "Luxury Innova for Shirdi from Pune"],
  ["Shirdi Temple Visit with Innova", "Group Travel for Shirdi Temple"],
  ["Book Shirdi Trip in Innova", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure timely pickups from your location in Pune and a smooth drive to Shirdi. Whether you are traveling for a religious visit, a family outing, or any other purpose, our drivers are committed to delivering you safely and on time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "The Toyota Innova is perfect for long-distance trips like Pune to Shirdi. With spacious seating, ample legroom, air conditioning, and a comfortable ride, you’ll feel relaxed and refreshed throughout the journey. It’s ideal for families, groups, or anyone traveling with luggage."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are not only experienced in long-distance travel but are also well-acquainted with the best routes from Pune to Shirdi. They are courteous, professional, and ensure a smooth and safe journey, giving you peace of mind while you travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing with no hidden charges. You’ll receive a clear breakdown of all costs upfront, so you know exactly what to expect. Our goal is to make your travel affordable and transparent while ensuring a high level of comfort and service."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Toyota Innova cars come equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride for you and your family on your journey to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return from Shirdi, S9 Travels is available 24/7 to accommodate your travel needs. Our customer service team is ready to assist you with bookings and any changes to your schedule."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Shirdi Innova rental is easy and convenient. You can book online through our website or mobile app, or simply contact our customer service team for personalized assistance. We’ll ensure your booking process is seamless and hassle-free."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling for religious purposes, a family outing, or a sightseeing trip in Shirdi, we offer customized travel packages to suit your needs. Let us know your preferences, and we’ll ensure your journey is special."
  }
]























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova for Pune to Shirdi with S9 Travels?',
            answer: 'Booking your Innova cab is simple! You can make your reservation online via our website or mobile app, or you can contact our customer service team for assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably accommodates up to 6 passengers, making it perfect for families or small groups traveling to Shirdi.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Pune to Shirdi?',
            answer: 'Yes, all of our drivers are highly experienced with long-distance travel and are familiar with the best routes to Shirdi, ensuring a smooth and safe journey.',
          },
          {
            question: 'What payment options are available for booking an Innova for Pune to Shirdi?',
            answer: 'We offer a variety of payment options including cash, credit/debit cards, and online payments via our app for your convenience.',
          },
          {
            question: 'Can I book a round trip from Pune to Shirdi?',
            answer: 'Yes, we can arrange a round trip. Just provide us with your return details, and we will ensure your travel is smooth and timely both ways.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting or detours will be communicated to you upfront, so you’ll know exactly what to expect.',
          },
          {
            question: 'Can I make extra stops during the journey to Shirdi?',
            answer: 'Yes, if you need to make additional stops during your trip, simply inform us when booking, and we’ll accommodate your requests.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have additional luggage or special requirements, let us know when booking, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Shirdi?',
            answer: 'Yes, we provide corporate travel services and group bookings for trips to Shirdi. Whether it\'s for employees, clients, or a group of friends, we ensure comfort and professionalism for every journey.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Shirdi Innova rental?',
            answer: 'S9 Travels offers affordable, comfortable, and reliable transport with experienced drivers and well-maintained vehicles. We prioritize your safety, comfort, and convenience to make your journey to Shirdi a pleasant experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Prakash Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Innova for a family trip to Shirdi, and it was a wonderful experience. The vehicle was spacious and comfortable, and the driver was very professional. We reached Shirdi on time, and the journey was smooth. Highly recommend S9 Travels!”',
        },
        {
          name: 'Mrs. Sunita Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our journey from Pune to Shirdi was fantastic with S9 Travels. The Innova was well-maintained and very comfortable. The driver was friendly and made sure we had a smooth ride. We’ll definitely book again for our next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Shirdi Innova Car Rental",
        "description": "Book an Innova cab for your Pune to Shirdi trip with S9 Travels. We offer one-way, round-trip, and private Innova taxis for a comfortable and affordable Shirdi temple visit. Group travel, luxury cabs, and affordable fares available.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "1500"
        }
      };
      
     


    return (
        <div>
          <Helmet>
        <title>Pune to Shirdi Innova Car Rental | Affordable & Comfortable Shirdi Taxi Service</title>
        <meta 
          name="description" 
          content="Book Pune to Shirdi Innova cab for your temple visit. One-way, round-trip, and group travel options available. Affordable and luxury taxis with professional drivers. Book your Shirdi Innova trip now!" 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/85.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdiinnovacarrental;